module.exports = __webpack_public_path__ + "a429882141b5f9e82388c4ca12190898.svg";